import { BreakpointValue } from 'consts/breakpoints';

export const NUMBER_OF_COLUMNS = 12;
export const GUTTER_WIDTH = 8;

export const CONTAINER_WIDTH: Record<BreakpointValue, string> = {
  1: 'auto',
  2: 'auto',
  3: '864px',
  4: '1152px',
  5: '1320px',
};

export const CONTAINER_MARGINS: Record<BreakpointValue, string> = {
  1: '16px',
  2: '40px',
  3: 'auto',
  4: 'auto',
  5: 'auto',
};
